import { render, staticRenderFns } from "./dictFooter.vue?vue&type=template&id=2827d855&scoped=true&lang=pug&"
import script from "./dictFooter.vue?vue&type=script&lang=js&"
export * from "./dictFooter.vue?vue&type=script&lang=js&"
import style0 from "./dictFooter.vue?vue&type=style&index=0&id=2827d855&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2827d855",
  null
  
)

export default component.exports